import React from "react";
import { FaNewspaper } from "react-icons/fa";

const newsArticles = [
  {
    id: 1,
    title: "Supporting Mental Health in Caregivers",
    date: "September 12, 2024",
    description:
      "Caregivers often face stress and emotional burnout. Learn strategies for supporting mental well-being while providing care.",
  },
  {
    id: 2,
    title: "How to Manage Time for Elderly Support",
    date: "September 10, 2024",
    description:
      "Managing time effectively when caring for elderly patients is crucial. Here are tips to help you balance care and self-care.",
  },
  {
    id: 3,
    title: "New Technologies for Home Care",
    date: "September 8, 2024",
    description:
      "Explore the latest innovations in home care technologies that improve patient well-being and streamline care tasks.",
  },
  {
    id: 4,
    title: "Understanding Palliative Care",
    date: "September 5, 2024",
    description:
      "Palliative care provides comfort for patients with serious illnesses. Learn more about what it entails and how it helps.",
  },
  {
    id: 5,
    title: "How to Stay Fit While Caring for Others",
    date: "September 3, 2024",
    description:
      "Balancing caregiving duties with your own fitness can be tough. Discover simple exercises and strategies for staying fit.",
  },
];

const NewsAreaComponent = () => {
  return (
    <div className="news-area-container">
      <h2 className="news-heading">Latest News & Updates</h2>
      <div className="news-grid">
        {newsArticles.map((article) => (
          <div key={article.id} className="news-card">
            <div className="news-content">
              <p className="news-date">{article.date}</p>
              <h3 className="news-title">{article.title}</h3>
              <p className="news-description">{article.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NewsAreaComponent;
